import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import ModernThemeBanner from '../components/ModernThemeBanner';

export default function MainLayout() {
  const location = useLocation();
  const pathArray = location.pathname.split('/');
  const isDisneylandAuth =
    pathArray[1] === 'disneyland' ||
    pathArray[1] === 'signup' ||
    pathArray[1] === 'forgotpassword';
  // Modern lounge is the default; only an explicit "off" opts out.
  let modernEnabled = true;
  try {
    modernEnabled = localStorage.getItem('mw_modern_lounge') !== 'off';
  } catch {
    /* ignore — treat as default (on) */
  }
  const wrapperClass = `wrapper${
    isDisneylandAuth && modernEnabled ? ' mw-lounge-modern' : ''
  }`;

  return (
    <>
      <Header />
      <div className={wrapperClass}>
        <div className='content'>
          <div className='container'>
            <Outlet />
          </div>
        </div>
      </div>
      {isDisneylandAuth && <ModernThemeBanner />}
    </>
  );
}
